module.exports = __webpack_public_path__ + "img/banner.1d06a58d.png";